import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 29 27"
    {...props}
  >
    <path
      fill="currentColor"
      d="M28 18H6.982q.5-.985 1-2.014c1.875.206 4.073-1.097 6.583-3.892.625 1.682 1.806 3.866 3.822 3.906 1.133.023 2.264-.65 3.428-2.046C22.663 14.969 24.412 16 28 16a1 1 0 0 0 0-2c-3.804 0-4.93-1.306-5-2.014a.96.96 0 0 0-.683-.969 1.02 1.02 0 0 0-1.156.437c-1.509 2.317-2.423 2.553-2.74 2.546-1.033-.02-2.083-2.44-2.443-4.177a1 1 0 0 0-1.76-.422c-2.526 3.168-4.218 4.234-5.272 4.51 1.061-2.358 1.854-4.43 2.361-6.173.853-2.93.915-4.98.189-6.263C11.12.802 10.328 0 8.738 0c-2.007 0-3.59 1.898-4.346 5.206-.449 1.964-.522 4.151-.202 6S5.173 14.4 6.138 15.2c-.466.965-.94 1.907-1.403 2.801H2a1 1 0 0 0 0 2h1.676c-1.415 2.625-2.515 4.455-2.533 4.485a1 1 0 1 0 1.714 1.03c.019-.032 1.409-2.349 3.088-5.515H28a1 1 0 0 0 0-2M6.342 5.651C6.84 3.468 7.803 2 8.738 2c.667 0 .888.232 1.017.459.375.666.815 3.024-2.708 10.799-1.032-1.41-1.384-4.633-.705-7.607"
    />
  </svg>
);
const SvgIconSignature = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSignature);
export default Memo;
